// @ts-nocheck
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import GlobalStyles from "@mui/material/GlobalStyles";
import { Grid } from "@mui/material";
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridColumnVisibilityModel
} from "@mui/x-data-grid";
import { StyledMainContainer, StyledDataGrid } from "./Main.styles";
import { GlobalContext } from "context/Provider";
import API from "api";
import Session from "helpers/session";
import { useTranslation } from "react-i18next";
import { host, socket_url } from "../../api/kore";
import io from "socket.io-client";
import {
  loadMembersContext,
  loadConfigurationsContext,
  loadNotificationsContext,
  createColumns,
  formatRows
} from "./Main.utils";
import { MEMBER_DISPATCHES } from "context/reducers/memberReducer";
import { COORDINATOR, ENCOUNTER, DEVELOPMENT } from "helpers/appConstants";

export default function Main() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const {
    member,
    memberDispatch,
    notificationsDispatch,
    configDispatch,
    encounterDispatch
  } = useContext(GlobalContext);
  const [loading, setLoading] = useState<boolean>(true);
  const [displayRows, setDisplayRows] = useState([]);
  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({
      lastMeasurement: false,
      riskAlerts: false
    });
  const currentEncounter = window.sessionStorage.getItem(ENCOUNTER)
    ? JSON.parse(
        Session.decrypt(window.sessionStorage.getItem(ENCOUNTER) || "")
      )
    : "";

  const loadEncounter = async () => {
    if (currentEncounter && currentEncounter?.actions.length !== 0) {
      const { memberId, memberName, member, actions } = currentEncounter;
      const eventBody = {
        coordinatorId: Session.crackCookieUserId(COORDINATOR),
        coordinatorName: Session.crackCookieUsername(COORDINATOR),
        memberId,
        memberName: memberName?.username || "",
        duration: member?.secondsCounter.toString() || "",
        escalatedDuration: 1,
        actions
      };
      await API.kore.encounters.add(
        Session.crackCookieToken(COORDINATOR),
        eventBody
      );
      window.sessionStorage.removeItem(ENCOUNTER);
    }
    const encounters = await API.kore.encounters.getList(
      Session.crackCookieToken(COORDINATOR)
    );
    encounterDispatch({ type: "UPDATE_LIST", payload: encounters });
  };

  const loadContext = async () => {
    const organization = Session.crackCookieUserOrg(COORDINATOR);
    const memberData = await loadMembersContext(memberDispatch);
    setColumnVisibilityModel(
      await loadConfigurationsContext(configDispatch, organization).tableOptions
    );
    await loadNotificationsContext(notificationsDispatch);
    setDisplayRows(
      await formatRows(memberData, memberDispatch, member.recents)
    );
    setLoading(false);
  };

  const goToReadings = (type: string, memberId: string, name: string) => {
    memberDispatch({
      type: MEMBER_DISPATCHES.changeTargetMember,
      payload: { name, memberId }
    });
    memberDispatch({ type: MEMBER_DISPATCHES.updateSeconds, payload: 0 });
    memberDispatch({ type: MEMBER_DISPATCHES.updateStart, payload: moment() });
    Session.initiateSessionEncounter(memberId, name);
    return navigate(
      `/patient/history/${type.toLowerCase().replace(" ", "")}/list/${memberId}`
    );
  };

  const goToMemberPage = (cell: any) => {
    memberDispatch({
      type: MEMBER_DISPATCHES.changeTargetMember,
      payload: { name: cell.row.member.name, id: cell.row.id }
    });
    memberDispatch({ type: MEMBER_DISPATCHES.updateSeconds, payload: 0 });
    memberDispatch({ type: MEMBER_DISPATCHES.updateStart, payload: moment() });
    Session.initiateSessionEncounter(cell.row.id, cell.row.member.username);
    navigate("/patient/vitals/" + cell.row.id);
  };

  useEffect(() => {
    loadContext().catch((e) => console.log("error: ", e));
    loadEncounter();
    if (process.env.REACT_APP_NODE_ENV !== DEVELOPMENT) {
      const socket = io(socket_url);
      socket.on(`${host[0]}-data-updates`, () => {
        loadContext(Session.crackCookieUserOrg(COORDINATOR));
        loadEncounter();
      });
    }
  }, []);

  return (
    <Grid container>
      <Grid item xs={0.1} />
      <Grid item xs={11.9}>
        <StyledMainContainer>
          <GlobalStyles
            styles={{ ".MuiDataGrid-panel": { top: "-120px !important" } }}
          />
          <StyledDataGrid
            rows={displayRows}
            rowHeight={85}
            columns={createColumns(t, goToReadings, goToMemberPage)}
            components={{
              Toolbar: () => {
                return (
                  <GridToolbarContainer
                    style={{
                      justifyContent: "flex-end"
                    }}
                  >
                    <GridToolbarColumnsButton />
                    <GridToolbarFilterButton />
                    <GridToolbarDensitySelector />
                  </GridToolbarContainer>
                );
              }
            }}
            componentsprops={{
              panel: {
                sx: {
                  top: 100
                }
              }
            }}
            rowsPerPageOptions={[5]}
            disableSelectionOnClick
            // onCellClick={goToMemberPage}
            initialState={{
              sorting: {
                sortModel: [{ field: "lastMeasurement", sort: "desc" }]
              },
              columns: {
                columnVisibilityModel: {
                  lastMeasurement: false,
                  riskAlerts: false
                }
              }
            }}
            loading={loading}
            getRowClassName={() => `super-app-theme--rows`}
          />
        </StyledMainContainer>
      </Grid>
    </Grid>
  );
}
